import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-adminextraescolares-grupos-crear',
  templateUrl: './adminextraescolares-grupos-crear.component.html',
  styleUrls: ['./adminextraescolares-grupos-crear.component.scss']
})
export class AdminextraescolaresGruposCrearComponent implements OnInit {

  constructor() { }



  ngOnInit() {
  }



}



// WEBPACK FOOTER //
// ./src/app/adminextraescolares-grupos-crear/adminextraescolares-grupos-crear.component.ts